import React from "react";
import { useState, useEffect } from "react";

import RoomHeader from "../RoomHeader";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import PoiItem from "./PoiItem.js";

import "./CommonPoisStyle.css";
import { FaLocationArrow } from "react-icons/fa";

import URWalkingMapData from "./mapped-ur-walking-ids.json";

const CommonPois = ({ selectedRoom }) => {
  const [URWalkingStart, setURWalkingStart] = useState("");

  const compileToURWalkingStartString = (str) => {
    const startElements = str.split(".");
    const startStr = `start=%5B${startElements.reverse().join(",")}%5D&`;
    setURWalkingStart(startStr);
  };

  useEffect(() => {
    const deriveToUrWalkingStart = () => {
      const mappedID = URWalkingMapData.UrWalkingMapped.filter((item) => {
        if (item.value === selectedRoom.raumcode) return true;
        else return false;
      });

      if (mappedID.length === 1) {
        const URWalkingStartLabel = mappedID[0].uid;
        if (URWalkingStartLabel !== "") {
          compileToURWalkingStartString(URWalkingStartLabel);
        }
      }
    };

    deriveToUrWalkingStart();
  }, [selectedRoom.raumcode]);

  return (
    <div>
      <RoomHeader
        title="Wegbeschreibung zu anderen Orten"
        subtitle={selectedRoom.hoersaal}
        icon={<FaLocationArrow className="section-indocator-icon" />}
      />

      <div className="swiper-slide-section pois-container">
        <p className="room-note">
          Mit dem Klick auf einen der Links werden Sie auf{" "}
          <a
            href={"https://urwalking.ur.de/navi/?v=ur"}
            target={"_blank"}
            rel="noreferrer"
          >
            UR.Walking
          </a>{" "}
          weitergeleitet. Nachfolgend finden Sie einige interessante Orte, die
          Sie von hier erreichen können:
        </p>

        <Accordion
          allowZeroExpanded={true}
          allowMultipleExpanded={false}
          preExpanded={["a"]}
        >
          <AccordionItem uuid="a">
            <AccordionItemHeading>
              <AccordionItemButton>
                <h3>Wegweiser auf dem Campus</h3>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B146,1,Campusplan%5D&v=ur`}
                title="Die Kugel"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B129,1,PT%5D&v=ur`}
                title="Wiese vor der PT Cafete"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B792,1,ChemiePharmazie%5D&v=ur`}
                title="Wiese vor der Chemie Cafete"
              />
            </AccordionItemPanel>
          </AccordionItem>

          <hr />

          <AccordionItem uuid="b">
            <AccordionItemHeading>
              <AccordionItemButton>
                <h3>Verwaltung</h3>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <Accordion
                allowZeroExpanded={true}
                allowMultipleExpanded={false}
                preExpanded={["ba"]}
              >
                <AccordionItem uuid="ba">
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <h3>
                        Stu&shy;die&shy;ren&shy;den&shy;an&shy;ge&shy;le&shy;gen&shy;hei&shy;ten
                      </h3>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B41,1,Wirtschaftsinformatik%5D&v=ur`}
                      title="Bibliothek"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B128,1,Rechenzentrum%5D&v=ur`}
                      title="Infostand des Rechenzentrums"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B169,2,sg%5D&v=ur`}
                      title="Zentrum für Sprache und Kommunikation (ZSK)"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B4,3,Studentenhaus%5D&v=ur`}
                      title="Ausbildungsförderung (BAföG)"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B129,1,Verwaltung%5D&v=ur`}
                      title="International Office"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B67,1,Verwaltung%5D&v=ur`}
                      title="Studentenkanzlei"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B21,2,Studentenhaus%5D&v=ur`}
                      title="Studienberatung"
                    />
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem uuid="bb">
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <h3>Sekretariate der Fakultäten</h3>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B107,1,PT%5D&v=ur`}
                      title="Fakultät Katholische Theologie"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B366,2,rw%5D&v=ur`}
                      title="Fakultät Rechtswissenschaft"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B366,2,rw%5D&v=ur`}
                      title="Fakultät Wirtschaftswissenschaften"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B551,2,Vorklinikum%5D&v=ur`}
                      title="Fakultät Medizin"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B79,1,PT%5D&v=ur`}
                      title="Fakultät Informatik und Data Science"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B107,1,PT%5D&v=ur`}
                      title="Fakultät Philosophie, Kunst-, Geschichts- und Gesellschaftswissenschaften"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B105,1,PT%5D&v=ur`}
                      title="Fakultät Humanwissenschaften"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B105,1,PT%5D&v=ur`}
                      title="Fakultät Sprach-, Literatur- und Kulturwissenschaften"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B168,3,Mathematik%5D&v=ur`}
                      title="Fakultät Mathematik"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B590,1,physik%5D&v=ur`}
                      title="Fakultät Physik"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B617,2,bioAusw%5D&v=ur`}
                      title="Fakultät Biologie und Vorklinische Medizin"
                    />
                    <PoiItem
                      href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B938,2,ChemiePharmazie%5D&v=ur`}
                      title="Fakultät Chemie und Pharmazie"
                    />
                  </AccordionItemPanel>
                </AccordionItem>
              </Accordion>
            </AccordionItemPanel>
          </AccordionItem>

          <hr />

          <AccordionItem uuid="c">
            <AccordionItemHeading>
              <AccordionItemButton>
                <h3>Essen &amp; Trinken</h3>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B32,1,mensa%5D&v=ur`}
                title="UR Mensa"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B4,2,othseybothstr%5D&v=ur`}
                title="OTH Mensa"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B792,1,ChemiePharmazie%5D&v=ur`}
                title="UR Cafete Chemie"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B20,1,mensa%5D&v=ur`}
                title="UR Cafete Mensa/Milchbar"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B129,1,PT%5D&v=ur`}
                title="UR Cafete PT"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B236,1,sg%5D&v=ur`}
                title="UR Cafete WiWi/Sammelgebäude"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B97,1,sport%5D&v=ur`}
                title="UR Cafete Sport"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B104,7,Zentralbibliothek%5D&v=ur`}
                title="UR Cafete Café Zentral"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B140,1,othgalgenberg%5D&v=ur`}
                title="OTH Cafete Maschinenbau"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B45,1,othseybothstr%5D&v=ur`}
                title="OTH Cafeteria Seybothstraße"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B1108,1,Campusplan%5D&v=ur`}
                title="Das Unikat"
              />
            </AccordionItemPanel>
          </AccordionItem>

          <hr />

          <AccordionItem uuid="d">
            <AccordionItemHeading>
              <AccordionItemButton>
                <h3>Verkehr &amp; Transit</h3>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B1114,1,Campusplan%5D&v=ur`}
                title="Busbahnhof"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B202,1,Campusplan%5D&v=ur`}
                title="Parkplatz Campus Nord"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B1032,1,Campusplan%5D&v=ur`}
                title="Parkhaus am Biopark P Süd 1"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B1033,1,Campusplan%5D&v=ur`}
                title="Parkhaus am Biopark P Süd 2"
              />
            </AccordionItemPanel>
          </AccordionItem>

          <hr />

          <AccordionItem uuid="e">
            <AccordionItemHeading>
              <AccordionItemButton>
                <h3>Geschäfte &amp; Läden</h3>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B201,1,Verwaltung%5D&v=ur`}
                title="Bankomat"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B965,1,Campusplan%5D&v=ur`}
                title="Bücher Pustet"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B157,1,Verwaltung%5D&v=ur`}
                title="Copyshop copy&amp;paper"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B156,1,Verwaltung%5D&v=ur`}
                title="Uni Friseure"
              />
              <PoiItem
                href={`https://urwalking.ur.de/navi/?${URWalkingStart}dest=%5B154,1,Verwaltung%5D&v=ur`}
                title="EDEKA markt Hechtbauer"
              />
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

export default CommonPois;
